import React, { useContext, useEffect, useMemo, useState } from "react";
import { Row, Col } from "antd";
import BedCards from "./BedCards";
import { getIpBedsListApi } from "../../../../services/receptionist.services";
import { getCookie } from "../../../../helpers/localStorage";
import { FacilityID } from "../../../../constants/defaultKeys";
import { UserContext } from "../../../../context/UserContext";
import ViewBeds from "./ViewBeds";
import { getBuildingListApi } from "../../../../services/beds.services";

const BedManagement = ({ patientData, refreshPage }) => {
  const { userDetails } = useContext(UserContext);
  const [buildings, setBuildings] = useState([]);
  const [buildingId, setBuildingId] = useState(null);
  const [roomId, setRoomId] = useState(null);
  const [beds, setBeds] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [editBed, setEditBed] = useState(false);
  const [switchBed, setSwitchBed] = useState(false);

  const refreshBedData = () => setRefresh((prev) => !prev);

  useEffect(() => {
    getBuildingListApi(Number(getCookie(FacilityID) || userDetails?.currFacility))
      .then((res) => {
        const list = Array.isArray(res?.data) ? res.data : [];
        setBuildings(list);
        if (list.length > 0) setBuildingId(list[0].id);
        setRoomId(null);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [userDetails, refresh]);

  const buildingStats = useMemo(
    () => buildings.find((building) => building.id === buildingId) || null,
    [buildings, buildingId]
  );

  useEffect(() => {
    if (buildingId || roomId) {
      const params = roomId
        ? `building=${buildingId}&room_type=${roomId}`
        : `building=${buildingId}`;
      getIpBedsListApi(
        Number(getCookie(FacilityID) || userDetails?.currFacility),
        params
      )
        .then((res) => setBeds(res?.data))
        .catch((err) => {
          console.log(err);
        });
    }
  }, [buildingId, roomId, refresh]);

  return (
    <Row gutter={[12, 12]}>
      {!patientData?.admission?.bed?.id || editBed || switchBed ? (
        <>
          <Col span={24}>
            <BedCards
              beds={beds?.data}
              patientData={patientData}
              refreshPage={refreshPage}
              refreshBedData={refreshBedData}
              editBed={editBed}
              setEditBed={setEditBed}
              switchBed={switchBed}
              setSwitchBed={setSwitchBed}
              showSelectionCancel={!!patientData?.admission?.bed?.id}
              onCancelSelection={() => {
                setEditBed(false);
                setSwitchBed(false);
              }}
              buildings={buildings}
              buildingId={buildingId}
              buildingStats={buildingStats}
              onBuildingChange={(val) => {
                setBuildingId(val);
                setRoomId(null);
              }}
            />
          </Col>
        </>
      ) : (
        <Col span={24}>
          <ViewBeds
            editBed={editBed}
            setEditBed={setEditBed}
            switchBed={switchBed}
            setSwitchBed={setSwitchBed}
            patientData={patientData}
            bedId={patientData?.admission?.bed?.id}
          />
        </Col>
      )}
    </Row>
  );
};

export default BedManagement;
